// @ts-nocheck

import { Target } from '../client';
import { CustomRouterHistory } from '../createHistory';

import RoutesRedirectionFactory from './routes/RoutesRedirectionFactory';

import { showWebsiteLoginForm } from './';

const loginDataRegExp = new RegExp('logindata=([^;]+)');
const isConnectedAtLeastOneTime = () => !!document.cookie.match(loginDataRegExp);

/**
 * @description Check if the user is logged, and show the login form if not
 */
export const checkIsLogged = (isConnected: boolean, history: CustomRouterHistory): boolean => {
  if (!isConnected) {
    if (Target.__MOBILE__) {
      history.push(
        RoutesRedirectionFactory.getLoginRouteConfig({ search: history.location.search, state: { modal: true } }),
      );
    } else {
      showWebsiteLoginForm();
    }
    return false;
  }

  return true;
};

export default {
  isConnectedAtLeastOneTime,
};

export const getJwtFromCookies = () => {
  const loginDataRegExp = new RegExp('_GTM=([^;]+)');
  const isJwtInCookie = !!document.cookie.match(loginDataRegExp);

  if (isJwtInCookie) {
    const name = '_GTM=';
    const cookies = document.cookie.split(';');

    for (let i = 0; i < cookies.length; ++i) {
      let cookie = cookies[i];
      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1, cookie.length);
      }
      if (cookie.indexOf(name) === 0) {
        return cookie.substring(name.length, cookie.length);
      }
    }
  }
  return null;
};
